import React, { useEffect, useState, useCallback } from 'react';
// import { Row, Col, Upload, Button, message, Select, DatePicker } from "antd";
// import { useForm, Controller } from "react-hook-form";
// import { UploadOutlined } from "@ant-design/icons";
import InformationForm from '../../form/subscription/InformationForm';
import useApplicationSession from '../../session/UserSession';
import { getUser } from '../../api';

const Information = () => {
    const [userdata, setUserdata] = useState(null);
    const token = useApplicationSession();
    const getUserInfo = useCallback(() => {
        if (token) {
            getUser({ token })
                .then((response) => {
                    const profile = response.data.profile ?? {};
                    profile.email = response.data.email;
                    profile.first_name = response.data.first_name;
                    profile.last_name = response.data.last_name;
                    profile.address_line_two = profile.previous_address;
                    setUserdata(profile);
                })
                .catch((error) => {});
        }
    }, [token]);

    useEffect(() => {
        getUserInfo();
    }, [getUserInfo]);

    return (
        <div test_id="subscription-information" className="subscriptionContentContainer">
            <InformationForm value={userdata} />
        </div>
    );
};

export default Information;
